import About from '../pages/About.svelte';
import Contact from '../pages/Contact.svelte';
import Home from '../pages/Home.svelte';
import Products from '../pages/Products.svelte';
const routes = [
    {
        name: 'Strona główna',
        path: '/',
        component: Home
    },
    {
        name: 'O nas',
        path: '/o-nas',
        component: About
    },
    {
        name: 'Produkty',
        path: '/produkty',
        component: Products
    },
    {
        name: 'Kontakt',
        path: '/kontakt',
        component: Contact
    }
];
export default routes;
